// extracted by mini-css-extract-plugin
module.exports = {"HeaderObserver":"header-observer_HeaderObserver__PyfMx"};